module.exports = __webpack_public_path__ + "img/norway-neoplasm-female.5cb15571.png";